<svelte:head>
    <title>Oxalt</title>

    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.0/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-gH2yIJqKdNHPEq0n4Mqa/HGKIhSkIHeL5AyhkYV8i59U5AR6csBvApHHNl/vI1Bx" crossorigin="anonymous">
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.2.0/dist/js/bootstrap.bundle.min.js" integrity="sha384-A3rJD856KowSb7dwlZdYEkO39Gagi7vIsF0jrRAoQmDKKtQBHUuLZ9AsSv4jD4Xa" crossorigin="anonymous"></script>
    <link rel="stylesheet" href="https://oxalt.fr/css/bootstrap.custom.min.css?v=5.1.3" type="text/css" media="screen" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.8.3/font/bootstrap-icons.css">

	<link rel="preconnect" href="https://fonts.googleapis.com">
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
	<link href="https://fonts.googleapis.com/css2?family=Roboto&display=swap" rel="stylesheet">

    <script type="module" src="https://cdn.jsdelivr.net/npm/@pwabuilder/pwainstall"></script>
    <script type="text/javascript">
        if ("serviceWorker" in navigator) {
            window.addEventListener("load", () => {
                navigator.serviceWorker.register("https://oxalt.fr/service-worker.js").then((reg) => {
                    //console.log("Service worker registered.", reg);
                });
            });
        }
    </script>

    {#if welcome}
        <style>
            body {
                height: 100%;
                font-family: 'Roboto', sans-serif;

                padding-top: 50px;

                background-image: url("/img/cover.jpg");
                background-attachment: fixed;
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;
            }
        </style>
    {:else}
        <style>
            body {
                font-family: 'Roboto', sans-serif;
            }

            .img-profile {
                width: 500px;
                height: 500px;
            }

            nav.bg-success#menu {
                background: rgb(172,187,245);
                background: linear-gradient(90deg, rgba(172,187,245,1) 0%, rgba(242,131,138,1) 85%);
            }
        </style>
    {/if}
</svelte:head>

<script>
	export let welcome = false;
</script>